
import { 
  Facebook, 
  Instagram, 
  Youtube, 
  Link, 
  Globe, 
  Music, 
  Linkedin, 
  Twitter, 
  BookOpen, 
  Newspaper, 
  Heart, 
  DollarSign 
} from "lucide-react";

export const linkTypeIcons = {
  facebook: Facebook,
  instagram: Instagram,
  youtube: Youtube,
  linkedin: Linkedin,
  twitter: Twitter,
  website: Globe,
  spotify: Music,
  blog: BookOpen,
  obituary: Heart,
  news_article: Newspaper,
  charity: Heart,
  memorial_fund: DollarSign,
  other: Link,
} as const;
